<template>
	<article
		:id="id"
		:class="['dc-post-grid-card', 'course-card']"
		v-on:click.stop.prevent="goToPost()"
	>
		<div ref="cardContentWrapper" class="content-wrapper">
			<div class="content-wrapper__inner">
				<img v-if="image" :src="image.src" :alt="image.alt" :srcset="image.srcset" />

				<div class="content-wrapper__inner">
					<h2 class="content-wrapper__inner__title">{{ title }}</h2>
					<p class="content-wrapper__inner__excerpt" v-if="excerpt">{{ excerpt }}</p>
				</div>

				<a href="">{{ dctxt('lesMerAlt') }}</a>
			</div>
		</div>
	</article>
</template>

<script>
import NansenCard from './NansenCard.vue';
import {Translatable} from '@dc-post-grid/mixins/Translatable';
export default {
	extends: NansenCard,
	mixins: [
		Translatable
	],
	props: {
	},
}
</script>

